var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"data-list-container vs-con-loading__container",attrs:{"id":"data-list-list-view"}},[_c('vx-card',[_c('template',{slot:"no-body"},[_c('vs-row',{staticStyle:{"position":"fixed","display":"block","width":"100%","height":"100%"},attrs:{"vs-w":"12"}},[_c('div',{staticStyle:{"position":"relative","width":"100%","height":"100%"}},[_c('span'),(_vm.showMap)?_c('GmapMap',{ref:"mapRef",staticStyle:{"width":"100%","height":"100%"},attrs:{"center":_vm.center,"zoom":9,"options":{
              zoom: 9,
              zoomControl: false,
              mapTypeControl: false,
              scaleControl: false,
              streetViewControl: false,
              rotateControl: false,
              fullscreenControl: false,
              disableDefaultUi: false,
            }}},[_c('GmapPolygon')],1):_vm._e()],1)])],1)],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }